var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 29,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "coin_svg__a",
  width: 33,
  height: 29,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M31.5 19.697a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M24 5.447v6.75a7.486 7.486 0 0 0-5.581 2.49 7.47 7.47 0 0 0-1.919 5.01 7.508 7.508 0 0 0 3.805 6.529c-1.996.604-4.646.971-7.555.971-6.213 0-11.25-1.679-11.25-3.75v-18"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M24 5.447c0 2.071-5.037 3.75-11.25 3.75S1.5 7.518 1.5 5.447c0-2.07 5.037-3.75 11.25-3.75S24 3.377 24 5.447Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.5 17.447c0 2.071 5.037 3.75 11.25 3.75 1.355 0 2.655-.08 3.858-.226M1.5 11.447c0 2.071 5.037 3.75 11.25 3.75 2.067 0 4.004-.186 5.669-.51M27 19.697h-3v-3"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#coin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFAB02",
  d: "M-1.5-3.553h36v36h-36v-36Z"
}))));
export default SvgCoin;